import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { store } from 'src/common/redux/configure-store';

export const approveRefundSwitchTender = async (): Promise<void> => {
  const transactionId: string = store.getState().transaction.transactionId;
  const axiosConfig: AxiosRequestConfig = {
    url: `/returns/${transactionId}/switch-tender-approval/`,
    method: 'POST',
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<void>(emeraldRequestParams);
};
